import { URLS } from 'api/constants';
import { apiGet } from './client';

export async function listPublicationComments(publicationId: string) {
  return apiGet<unknown>(`${URLS.COMMENTS_BY_PUBLICATION}${publicationId}`);
}
